export default "__VITE_ASSET__ESxrfYOg__"